import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { QuestionBankPagesMixin, initQuestionBankAvailableQuestionSelect, renderQuestionBankPagesSection, renderQuestionBankUniqueIdentifierLabel } from '~/components/templates/recruiting/questionBankPagesSection';
import { html, LpButton, LpPageHeader, LpSectionHeader } from '~/design-system';
export class adminQuestionBankEdit_template extends vnTemplate {
    constructor() {
        super(...arguments);
        this.questionBankPages = new QuestionBankPagesMixin();
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        initQuestionBankAvailableQuestionSelect(this.getTemplateViewModel(), this.caller);
    }
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminQuestionBankEdit-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            id: ko.observable(null),
            identifier: ko.observable(''),
            active: ko.observable(false),
            hideAdditionalQuestions: ko.observable(false),
            pages: ko.observableArray([]),
            availableQuestions: ko.observableArray([]),
            onClickBack: function () { self.caller.backToQuestionBanks(); },
            onClickSave: function () { self.caller.saveQuestionBank(); },
            onClickDelete: function () { self.caller.deleteQuestionBank(); },
            onClickAddPage: function () { self.onClickAddPage(); },
            onClickDeletePage: function (page) { self.onClickDeletePage(page); },
            onClickAddQuestion: function (page) { self.onClickAddQuestion(page); },
            onClickRemoveQuestion: function (page, xref) { self.onClickRemoveQuestion(page, xref); },
            onQuestionDragDrop: function (page, dragged, target) { self.onQuestionDragDrop(page, dragged, target); },
            onPageDragDrop: function (dragged, target) { self.onPageDragDrop(dragged, target); },
            onClickMoveQuestionUp: function (page, xref) { self.onClickMoveQuestion(page, xref, -1); },
            onClickMoveQuestionDown: function (page, xref) { self.onClickMoveQuestion(page, xref, 1); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? 'Edit Question Bank' : 'Create Question Bank'"></span>`,
            description: 'Configure question bank identity, active state, and assigned pages.',
            icon: 'cards',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Delete',
                prefixIcon: 'trash',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: id, click: onClickDelete',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}
                `,
        })}

            <div class="edit-page edit-page--question-bank">
                <div class="question-bank-summary-card">
                    <div class="question-bank-summary-card__content">
                        <section class="question-bank-summary-section">
                            ${LpSectionHeader({
            title: 'Identity',
            description: 'Name this bank for widget configuration and reporting.',
            level: 3,
        })}
                            <div class="form-group">
                                ${renderQuestionBankUniqueIdentifierLabel()}
                                <input class="input edit-input" type="text" data-bind="value: identifier" placeholder="Unique identifier used by the widget caller" />
                            </div>
                        </section>

                        <section class="question-bank-summary-section question-bank-settings">
                            ${LpSectionHeader({
            title: 'Behavior',
            level: 3,
        })}
                            <div class="question-bank-settings__list">
                                ${this.renderQuestionBankSwitch({
            title: 'Active',
            description: 'Enable this question bank for recruiting flows.',
            checkedBinding: 'active',
        })}
                                ${this.renderQuestionBankSwitch({
            title: 'Conditional service fields',
            description: 'Only show Branch, Pay Grade, and Separation Date when Prior Service is selected.',
            checkedBinding: 'hideAdditionalQuestions',
        })}
                            </div>
                        </section>
                    </div>
                </div>

                <section class="question-bank-assigned-pages" id="question-bank-edit-results">
                    ${renderQuestionBankPagesSection()}
                </section>
            </div>
        `;
    }
    /**
     * Render an accessible switch bound to a Knockout boolean observable.
     *
     * @param options Switch content and binding.
     * @return string
     */
    renderQuestionBankSwitch(options) {
        return `
            <div class="question-bank-setting">
                <div class="question-bank-setting__heading">
                    <span class="question-bank-setting__title">${options.title}</span>
                    <label class="question-bank-switch" data-bind="css: { 'is-on': ${options.checkedBinding} }">
                        <input class="question-bank-switch__input" type="checkbox" data-bind="checked: ${options.checkedBinding}" />
                        <span class="question-bank-switch__track" aria-hidden="true">
                            <span class="question-bank-switch__thumb"></span>
                        </span>
                    </label>
                </div>
                <p>${options.description}</p>
            </div>
        `;
    }
    /**
     * Set available questions on the view model.
     *
     * @param questions Array<any>
     * @return void
     */
    setAvailableQuestions(questions) {
        this.questionBankPages.setAvailableQuestionsOnVm(this.getTemplateViewModel(), questions);
    }
    setBank(bank) {
        const vm = this.getTemplateViewModel();
        vm.id(bank && bank.id ? Number(bank.id) : null);
        vm.identifier(bank && bank.identifier ? bank.identifier : '');
        vm.active(!!(bank && bank.active));
        vm.hideAdditionalQuestions(!!(bank && bank.hideAdditionalQuestions));
        vm.pages(this.questionBankPages.normalizePages(bank && bank.pages ? bank.pages : [], vm, this.caller));
    }
    getPayload() {
        const vm = this.getTemplateViewModel();
        return {
            id: vm.id(),
            identifier: vm.identifier(),
            active: vm.active(),
            hideAdditionalQuestions: vm.hideAdditionalQuestions(),
            pages: this.questionBankPages.buildPagesPayload(vm.pages()),
        };
    }
    onClickAddPage() {
        this.questionBankPages.addPageToVm(this.getTemplateViewModel(), this.caller);
    }
    onClickDeletePage(page) {
        this.questionBankPages.deletePageFromVm(this.getTemplateViewModel(), page);
    }
    onClickAddQuestion(page) {
        this.questionBankPages.addQuestionToPage(this.getTemplateViewModel(), page);
    }
    onClickRemoveQuestion(page, xref) {
        this.questionBankPages.removeQuestionFromPage(page, xref);
    }
    onQuestionDragDrop(page, dragged, target) {
        this.questionBankPages.reorderQuestionOnPage(page, dragged, target);
    }
    onPageDragDrop(dragged, target) {
        this.questionBankPages.reorderPageInVm(this.getTemplateViewModel(), dragged, target);
    }
    onClickMoveQuestion(page, xref, direction) {
        this.questionBankPages.moveQuestionOnPage(page, xref, direction);
    }
}
